/**
 * @readonly
 * @enum {number}
 */
const ErrorCode = Object.freeze({
  TOPIC_INACCESSIBLE_ERROR: 2002,
  TOPIC_MANAGER_INDEX_NOT_READY_ERROR: 3502,
  PERMISSION_DENIED: 10000,
  COMPARE_INVALID_FILTER: 23001,
  THEME_INACCESSIBLE_ERROR: 2050,
  DASHBOARD_CAN_NOT_ADD_LIVEREPORT_SUBSCRIBER: 18003,
  ADMIN_NO_EXECUTIVE_USER_QUOTA: 22703,
  PERMISSION_DENIED_INSUFFICIENT_LIVE_REPORT_QUOTA: 10031,
  ADMIN_USER_NOT_FOUND: 22001,
  PERMISSION_DENIED_UNSUFFICIENT_ALERT_QUOTA: 10009
})
export default ErrorCode
